import apiClient from '../client';
import ENDPOINTS from '../endpoints';

/* API tag ids ↔ the UI's DIET_TAGS ids. */
const TAG_TO_API = { veg: 'vegetarian', vegan: 'vegan', prek: 'preK', gf: 'glutenFree', local: 'localIngredients' };
const TAG_FROM_API = Object.fromEntries(Object.entries(TAG_TO_API).map(([ui, api]) => [api, ui]));

let optionSeq = 1000;

const toUiOptions = (list) =>
  (list || []).map((o) => ({
    id: ++optionSeq,
    text: o?.name || '',
    tags: (o?.tags || []).map((t) => TAG_FROM_API[t]).filter(Boolean),
  }));

const toApiOptions = (list) =>
  (list || []).map((o) => ({
    name: o.text || '',
    tags: (o.tags || []).map((t) => TAG_TO_API[t]).filter(Boolean),
  }));

const lunchService = {
  /* Day key is lowercase for the API ('Mon' → 'mon'). Returns UI-shaped
     { breakfast, lunch } or null when no menu is saved for that day. */
  getDay: async (day, schoolId) => {
    try {
      const res = await apiClient.get(ENDPOINTS.ROOM_PARENT_ADMIN.LUNCH_MENU(day.toLowerCase()), {
        params: { schoolId },
      });
      const rec = res?.data?.data || res?.data || null;
      if (!rec || (!rec.breakfast && !rec.lunch)) return null;
      return { breakfast: toUiOptions(rec.breakfast), lunch: toUiOptions(rec.lunch) };
    } catch (err) {
      if (err.status === 404) return null;
      throw err;
    }
  },

  saveDay: (day, schoolId, { breakfast, lunch }) =>
    apiClient.put(ENDPOINTS.ROOM_PARENT_ADMIN.LUNCH_MENU(day.toLowerCase()), {
      schoolId,
      breakfast: toApiOptions(breakfast),
      lunch: toApiOptions(lunch),
    }),
};

export default lunchService;
